// extracted by mini-css-extract-plugin
export var close = "SideDrawer-module--close--BrL60";
export var close_btn = "SideDrawer-module--close_btn--4NKR3";
export var donate_btn = "SideDrawer-module--donate_btn--FatKK";
export var logo = "SideDrawer-module--logo--807mf";
export var mobile_nav = "SideDrawer-module--mobile_nav--dfYhO";
export var open = "SideDrawer-module--open--MBd1D";